export default __webpack_public_path__ + "static/jobbox-3-a-8a081640f135592d62c8c29ba39efeb6.webp";